const assign = require('lodash/assign')

module.exports = [
  '$q',
  'User',
  function($q, User) {
    return {
      wrapper: function (func, defaultData) {
        function WrapCall(f, d) {
          this.func = f
          this.defaultData = d

          this.xhr = (data) => {
            const deferred = $q.defer()
            User.getCurrentUser().simpleCall({
              query: {
                func: this.func,
                sid: User.getCurrentUser().sid
              },
              data: this.defaultData ? assign(this.defaultData, data) : data
            }).then(function (data) {
              deferred.resolve(data)
            }, function (error) {
              deferred.reject(error)
            })
            return deferred.promise
          }
        }
        return new WrapCall(func, defaultData).xhr
      },
      wmCall: function (func, data) {
        const deferred = $q.defer()
        User.getCurrentUser().simpleCall({
          query: {
            func: func,
            sid: User.getCurrentUser().sid,
          },
          data: data,
        }).then(function (data) {
          deferred.resolve(data)
        }, function (error) {
          deferred.reject(error)
        })
        return deferred.promise
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/infrastructure/Promise.js